import type { HeaderNavItem } from '../types/headerNav';

export function sortNavItems(items: HeaderNavItem[]): HeaderNavItem[] {
  return [...items].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

export function getNavHref(item: HeaderNavItem): string {
  if (item.linkType === 'category' && item.categorySlug) {
    return `/category/${item.categorySlug}`;
  }
  if (item.linkType === 'collection' && item.collectionSlug) {
    return `/products?collection=${encodeURIComponent(item.collectionSlug)}`;
  }
  return item.url || '/';
}

export function isExternalNav(item: HeaderNavItem): boolean {
  return item.linkType === 'external' || item.openInNewTab === true;
}
